import { DashboardApp } from "dashboard/DashboardApp";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const homeRoute: RouteObject = {
  index: true,
  loader: () => viewModel,
  Component: DashboardApp,
};